export {default} from './OnboardingTile';
